var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonGrid',{attrs:{"buttons":_vm.supportMaterials},scopedSlots:_vm._u([{key:"button",fn:function(ref){
var button = ref.button;
return _c('button',{class:"ui basic fluid icon button",on:{"click":function($event){return _vm.download(button)}}},[_c('i',{class:"ui file outline icon"}),_vm._v(" "+_vm._s(button)+" ")])}}])})}
var staticRenderFns = []

export { render, staticRenderFns }